import { AfterViewInit, Component, DebugElement, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Messages } from 'src/app/modules/compliance/constants/messages';
import { emptyNotes, emptyNoteSearchParam } from 'src/app/modules/compliance/constants/prepareEmptyObject';
import { INote, INoteSearchParam } from '../../model/note';
import { NoteService } from '../../services/note.service';
import { ApiResult } from '@app/shared/model/apiresult';
import { ELookup } from '@app/modules/compliance/constants/eLookup';
import { ILookup } from '@app/shared/model/lookup';
import { LookupService } from '../../../maintenance/services/lookup.service';
import { Guid } from 'guid-typescript';
import { ActivatedRoute } from '@angular/router';
import { environment as env } from '@environments/environment'
import { AuthService } from '@app/core/auth/auth.service';

@Component({
    selector: 'app-notes',
    templateUrl: './note.component.html'
})
export class NotesComponent implements OnInit, AfterViewInit {
    @Input() WriteAction:boolean=false;
    @Input() NoteTypeCode:string='';
    private noteTypeId:number;
    public notesFormGroup: UntypedFormGroup;
    public noteTypeList: ILookup[];
    public note: INote = emptyNotes();
    public noteSearch:INoteSearchParam = emptyNoteSearchParam();
    isShown: boolean = false;
    studentID: Guid;
    displayedColumns: string[] = ['noteType', 'content', 'createdBy', 'updatedDate'];
    dataSource = new MatTableDataSource<INote>();
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    constructor(public auth: AuthService,
        private _snackBar: MatSnackBar,
        private _formBuilder: UntypedFormBuilder,
        private _lookupservice: LookupService,
        private _noteservice: NoteService,
        private _route: ActivatedRoute) {
        //Form Group Initiation.
        this.fillForm(this.note);
    }
    ngOnInit() {      

        this._route.queryParams.subscribe(params => {
            this.studentID = params.id;
        });

        this.getActiveLookups(ELookup.NoteType);
        this.getNotesById();
    }

    ngAfterViewInit(): void {
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
      }
    
    private getActiveLookups(tableName: string) {
        this._lookupservice.getActiveLookups(tableName).subscribe((result: ApiResult<ILookup[]>) => {
            if (result.validationErrors == null) {
                switch (tableName) {
                    case ELookup.NoteType:
                        if(this.NoteTypeCode != '')
                        {
                            this.noteTypeList = result.value.filter((nt) => nt.code.indexOf(this.NoteTypeCode) >= 0);
                            this.noteTypeId = this.noteTypeList[0].id;
                            this.getNotesById();
                        }
                        else
                            this.noteTypeList = result.value;
                        break;
                    default:
                        break;
                }
            }
        }, error => console.error(error));
    }    
    cancel() {
        this.note = emptyNotes();
        this.isShown = false;
        this.fillForm(this.note);
    }
    add() {
        this.note = emptyNotes();
        this.isShown = true;
        this.fillForm(this.note);
    }
    edit(noteData: INote) {
        this.isShown = true;
        this.note = noteData;
        this.fillForm(this.note);
    }

    private getNotesById() {
        this.noteSearch.studentId = this.studentID;
        if(this.noteTypeId != null)
            this.noteSearch.noteTypeId = this.noteTypeId;
        this._noteservice.search(this.noteSearch).subscribe((result: ApiResult<INote[]>) => {
            if (result.validationErrors == null) {
                this.dataSource = new MatTableDataSource<INote>(result.value);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }
        }, error => console.error(error));
    }

    private fillForm(notesInfo: INote) {
        this.notesFormGroup = this._formBuilder.group(
            {
                content: [notesInfo.content],
                noteTypeId: [notesInfo.noteTypeId],
            });
    }

    public onSubmit() {
        this.note.studentId = this.studentID;
        this.note.content = this.notesFormGroup.value.content;
        this.note.noteTypeId = this.notesFormGroup.value.noteTypeId;
        this.note.tenantId =  Guid.parse(env.tenantId).toJSON().value;
        this.note.updatedDate = new Date();

        if (this.note.noteId != null) {
            this._noteservice.put(this.note).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.notify();
                    this.getNotesById();
                }
                else{
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
        else {
            this.note.noteId = Guid.createEmpty().toJSON().value;
            this._noteservice.post(this.note).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.cancel();
                    this.notify();
                    this.getNotesById();
                }else
                {
                    this.note.noteId = null;
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
    }

    notifyWarnings(message: string[]) {
        let snackBarRef = this._snackBar.open(message[0], "Close", {
            duration: 5000,
            panelClass: ['error-border']
        });     
    }

    notify() {
        let snackBarRef = this._snackBar.open(Messages.NoteSaved, "Close", {
            duration: 2000,
        });      
    }

    // Evaluate Bind
    evalBind(data:ILookup,currentValue:number){
        if(data.id==currentValue){
            return true;
        }
      return !data.disabled;
    }


}
